<template>
    <div class="deal-schedule-box">
        1111
        <!-- <el-dialog :visible.sync="dealScheduleDialog" width="650px" :show-close="false" :close-on-click-modal="false">
            <header slot="title" class="order-schedule-header">
                <h4>查看预约日程</h4>
                <i class="el-icon-close" @click="handleClose"></i>
            </header>
            <div class="content">
                <p>
                    <span v-if="orderDetail.ifButton"
                        >预约发起人：{{ orderDetail.userInfo ? orderDetail.userInfo.name : "" }}
                        {{ orderDetail.userInfo.orgName }}</span
                    >
                    <span v-else
                        >被预约人（协作者）：{{
                            orderDetail.appointmetnUserInfo ? orderDetail.appointmetnUserInfo.name : ""
                        }}
                        {{ orderDetail.appointmetnUserInfo.orgName }}</span
                    >
                    <span>创建时间：{{ orderDetail.createDate }}</span>
                </p>
                <p>开始时间：{{ orderDetail.docStartTime | wipeOutSec }}</p>
                <p>
                    结束时间：{{ orderDetail.docFinishTime | wipeOutSec }}
                    <span v-if="isShowConflict" class="conflictIcon">时间冲突</span>
                </p>

                <p>预约主题：{{ orderDetail.docSubject }}</p>
                <el-button
                    v-if="
                        !orderDetail.ifButton &&
                            $store.state.user.oauth.userId == orderDetail.userInfo.userId &&
                            orderDetail.status == 0
                    "
                    size="small"
                    type="primary"
                    style="display:block;margin:30px auto;margin-bottom:0;width:120px;"
                    @click="repealSchedule(orderDetail)"
                    >撤销</el-button
                >
                <h4 v-if="orderDetail.ifButton">意见反馈：</h4>
                <el-input
                    v-if="orderDetail.ifButton"
                    v-model="handleParmas.feedbackContent"
                    type="textarea"
                    placeholder="请填写意见反馈（不超过200字）"
                    :autosize="{ minRows: 5, maxRows: 10 }"
                    maxlength="200"
                ></el-input>
            </div>
            <span v-if="orderDetail.ifButton" slot="footer" class="dialog-footer">
                <el-button size="small" style="margin-bottom:10px;width:120px;" @click="handleSchedule(false)"
                    >拒绝</el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    style="margin-bottom:10px;width:120px;"
                    @click="handleSchedule(true)"
                    >同意</el-button
                >
            </span>
        </el-dialog> -->
    </div>
</template>

<script>
export default {
    components: {},
    filters: {
        wipeOutSec(date) {
            return date.slice(0, 16);
        },
    },
    props: {
        dealScheduleDialog: {
            type: Boolean,
            default: false,
        },
        // orderdetail: {
        //     type: Object | String,
        //     default: () => {
        //         return {
        //             userInfo: {
        //                 name: "",
        //             },
        //         };
        //     },
        // },
    },

    data() {
        return {
            handleParmas: {
                id: "",
                status: "", //同意或者拒绝  同意：AGREE  拒绝：REFUSE
                feedbackContent: "",
            },
            isShowConflict: false,
        };
    },

    // created() {
    //     this.$axios
    //         .post("/schedule/management/user/conflict", {
    //             id: "",
    //             conflictVO: [],
    //             appointmentId: this.orderDetail.appointmetnUserInfo.userId,
    //             startDate: `${this.orderDetail.docStartTime}:00`,
    //             endDate: `${this.orderDetail.docFinishTime}:00`,
    //         })
    //         .then((result) => {
    //             result.body = result.body || [];
    //             if (result.body.length == 0) {
    //                 this.isShowConflict = false;
    //             }
    //             if (result.body[0].id == this.orderDetail.appointmetnUserInfo.userId) {
    //                 this.isShowConflict = true;
    //             }
    //         });
    // },
    mounted() {},
    methods: {
        /**
         * 处理预约日程
         */
        // handleSchedule(type) {
        //     this.handleParmas.id = this.orderDetail.id;
        //     if (type) this.handleParmas.status = "AGREE";
        //     else this.handleParmas.status = "REFUSE";
        //     this.$axios
        //         .post("/schedule/appointment/updateStatus", this.handleParmas)
        //         .then((res) => {
        //             this.$message.success(type ? "已同意" : "拒绝成功");
        //             this.$emit("handleSuccess");
        //         })
        //         .catch((err) => {
        //             this.$message.error(err.data.message);
        //         });
        // },
        // handleClose() {
        //     this.$emit("handleClose");
        // },
        /**
         * 撤销
         */
        // repealSchedule(item) {
        //     this.$confirm("确定撤回此次预约?", "提示", {
        //         message: `<div>
        //   <p>确定撤回此次预约?</p>
        //   <p>内容：${item.docSubject}</p>
        //  </div>`,
        //         dangerouslyUseHTMLString: true,
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning",
        //     }).then((res) => {
        //         this.$axios
        //             .put("/schedule/appointment/cancel", {
        //                 id: item.id,
        //             })
        //             .then((res) => {
        //                 this.$message.success("撤销成功！");
        //                 this.$emit("handleSuccess");
        //                 this.$emit("handleClose");
        //             });
        //     });
        // },
    },
};
</script>
<style lang="scss">
.deal-schedule-box {
    .el-dialog {
        border-radius: 8px;
        box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.32);
    }
    .el-dialog__header {
        background: #f0f1f3;
        height: 44px;
        padding: 10px 20px;
        border-radius: 8px 8px 0 0;
        .order-schedule-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            h4 {
                color: $primary;
                font-size: 16px;
                font-weight: normal;
            }
            .el-icon-close {
                cursor: pointer;
                font-size: 16px;
                &:hover {
                    color: $primary;
                }
            }
        }
    }
    .el-dialog__body {
        padding: 25px;
    }
    .el-form-item {
        margin-bottom: 15px;
    }
    .el-dialog__footer {
        text-align: center;
    }
}
</style>
<style lang="scss" scoped>
.content {
    p {
        // font-size: 16px;
        display: flex;
        &:first-child {
            justify-content: space-between;
        }
        > span {
            font-size: 16px;
        }
        margin-bottom: 16px;
    }
    h4 {
        margin-top: 30px;
        margin-bottom: 10px;
    }
}
.conflictIcon {
    display: inline-block;
    position: relative;
    top: -15px;
    left: 20px;
    color: red;
    border-radius: 8px;
    width: 64px;
    height: 16px;
    line-height: 16px;
    background: #ff0707;
    color: #fff;
    font-size: 12px !important;
    text-align: center;
}
</style>
